import styled, { createGlobalStyle } from 'styled-components'
import { themeGet } from 'styled-system'
import { Button } from 'grommet'

export const PrintStyles = createGlobalStyle`
  @media print {
    /* Hide non-print controls on this page */
    [data-print-hidden='navigation'],
    [data-print-hidden='mark-done'],
    [data-print-hidden='teach-button'],
    [data-print-hidden='language-toggle'],
    [data-print-hidden='print-button'],
    ._pendo-step-container-styles,
    .NavTabSet,
    [class*='NavTabSet'],
    .global-nav-container,
    .AccordionWrapper,
    [class*='AccordionWrapper'] {
      display: none !important;
    }

    /* Scale print output down to 90% in print preview/output */
    @supports (zoom: 1) {
      .individual-resource-print-page {
        zoom: 0.9;
      }
    }
    @supports not (zoom: 1) {
      .individual-resource-print-page {
        transform: scale(0.9);
        transform-origin: top left;
        width: 111.112%;
      }
    }
  }
`

export const PrintActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: calc(100% - 2.5rem);
  max-width: ${themeGet('breakpoints.sizes.large')};
  margin: 1rem auto 0.75rem;

  ${themeGet('breakpoints.mobileLarge')} {
    width: calc(100% - 2rem);
    align-items: center;
    justify-content: center;
  }
`

export const PrintButton = styled(Button).attrs({
  type: 'button',
})`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${themeGet('colors.buttons.primary.bgActive')};
  color: ${themeGet('colors.buttons.primary.titleActive')};
  border: 0.0625rem solid ${themeGet('colors.buttons.primary.bgActive')};
  border-radius: 0.5rem;
  height: 2.688rem;
  padding: 0.5rem 1rem;
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1rem;
  line-height: 1.063rem;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  min-width: 9.375rem;
  transition: background-color 0.2s ease, border-color 0.2s ease,
    color 0.2s ease;

  :hover {
    background: ${themeGet('colors.buttons.primary.bgHover')};
    color: ${themeGet('colors.buttons.primary.titleHover')};
    border-color: ${themeGet('colors.buttons.primary.bgHover')};
  }

  :focus {
    outline: 0.125rem solid
      ${themeGet('individualResource.teachButton.focusOutline')};
    outline-offset: 0.125rem;
  }

  ${themeGet('breakpoints.tabletLarge')} {
    margin-bottom: 1.25rem;
  }
`
